require('./accountDirectDebitSuccessStep.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @commons
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

class AccountDirectDebitSuccessStep extends React.Component {
    render() {
        const { selectedAccountId } = this.props;
        const goBackButtonLabel = <FormattedText value="accountDirectDebitSuccess-mainButton" format="uppercase"/>;
        const linkToDetails = `/myprofile/accounts/${selectedAccountId}/debits`;
        const mainButton = {
            label: goBackButtonLabel,
            url: linkToDetails
        };

        return (
            <div className="account-direct-debit-success col-xs-9 center-block">
                <WizardSuccess
                    successMessage={formatText('accountDirectDebitSuccess-title')}
                    mainButton={mainButton}
                >
                    <FormattedText
                        className="account-direct-debit-success__content"
                        value="accountDirectDebitSuccess-content"
                    />
                </WizardSuccess>
            </div>
        );
    }
}

AccountDirectDebitSuccessStep.propTypes = {
    selectedAccountId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};

module.exports = AccountDirectDebitSuccessStep;
